import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { APP_NAME, IS_APP_PRODUCTION } from "../constants/app";
import { format } from "date-fns";
import moment from 'moment';

const characterList = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const CookieList = ["accessToken", "refreshToken"];

export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export function getCurrentUrl(location) {
	return location.pathname.split(/[?#]/)[0];
}
export function checkIsActive(location, url) {
	const current = getCurrentUrl(location);
	const currentSplit = current.split("/");

	if (!current || !url) {
		return false;
	}

	if (current === url) {
		return true;
	}

	if (url.split("/").every((urlPiece) => currentSplit.includes(urlPiece))) {
		return true;
	}

	return false;
}

export function generateCookiesName() {
	let secretCode = 10;
	for (let i = 0; i < APP_NAME.length; i++) {
		secretCode += APP_NAME.charCodeAt(i) * APP_NAME.length;
	}

	secretCode = Math.round(secretCode / APP_NAME.length);
	let GeneratedCookiesName = {};
	CookieList.forEach((cookie) => {
		let tempCookieString = "";
		for (let j = 0; j < cookie.length; j++) {
			let charCode = Math.floor((cookie.charCodeAt(j) * characterList.length * cookie.length) / secretCode);
			charCode = charCode > characterList.length ? charCode - characterList.length : charCode;
			tempCookieString += characterList.charAt(Math.floor(charCode));
		}

		GeneratedCookiesName[cookie] = tempCookieString;
	});
	return GeneratedCookiesName;
}
export function generatePredictableUniqueKeyName(key) {
	let secretCode = 10;
	for (let i = 0; i < APP_NAME.length; i++) {
		secretCode += APP_NAME.charCodeAt(i) * APP_NAME.length;
	}

	secretCode = Math.round(secretCode / APP_NAME.length);
	let uniqueKeyString = "";
	for (let j = 0; j < key.length; j++) {
		let charCode = Math.floor((key.charCodeAt(j) * characterList.length * key.length) / secretCode);
		charCode = charCode > characterList.length ? charCode - characterList.length : charCode;
		uniqueKeyString += characterList.charAt(Math.floor(charCode));
	}
	return uniqueKeyString;
}
export const generatedCookies = generateCookiesName();
export const storage = IS_APP_PRODUCTION
	? {
			getToken: () => Cookies.get(generatedCookies.accessToken) && CryptoJS.AES.decrypt(Cookies.get(generatedCookies.accessToken), APP_NAME).toString(CryptoJS.enc.Utf8),
			setToken: (token) =>
				Cookies.set(generatedCookies.accessToken, CryptoJS.AES.encrypt(token, APP_NAME).toString(), { secure: true, path: IS_APP_PRODUCTION ? `/` : `/${APP_NAME}`, expires: 0.5 }),
			clearToken: () => Cookies.remove(generatedCookies.accessToken, { path: IS_APP_PRODUCTION ? `/` : `/${APP_NAME}` }),
			setSessionStorage: (key, value) => window.sessionStorage.setItem(generatePredictableUniqueKeyName(key), JSON.stringify(value)),
			getSessionStorage: (key) => window.sessionStorage.getItem(generatePredictableUniqueKeyName(key)) && JSON.parse(window.sessionStorage.getItem(generatePredictableUniqueKeyName(key))),
	  }
	: {
			getToken: () =>
				window.localStorage.getItem(generatedCookies.accessToken) &&
				CryptoJS.AES.decrypt(window.localStorage.getItem(generatedCookies.accessToken), APP_NAME).toString(CryptoJS.enc.Utf8),
			setToken: (token) => window.localStorage.setItem(generatedCookies.accessToken, CryptoJS.AES.encrypt(token, APP_NAME).toString()),
			clearToken: () => window.localStorage.removeItem(generatedCookies.accessToken),
			setSessionStorage: (key, value) => window.sessionStorage.setItem(generatePredictableUniqueKeyName(key), JSON.stringify(value)),
			getSessionStorage: (key) => window.sessionStorage.getItem(generatePredictableUniqueKeyName(key)) && JSON.parse(window.sessionStorage.getItem(generatePredictableUniqueKeyName(key))),
	  };
export const toCapitalize = (word = "") => {
	return word[0].toUpperCase() + word.slice(1).toLowerCase();
};

export const toCamelize = (str) => {
	return str
		.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
			return index === 0 ? word.toLowerCase() : word.toUpperCase();
		})
		.replace(/\s+/g, "");
};

export const formatToCurrency = (num) => {
	let formatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",

		//These options are needed to round to whole numbers if that's what you want.
		//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
		//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
	});
	return formatter.format(num);
};


export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export const unFormatNumber = (formattedNumber) => {
	var thousandSeparator = (1111).toLocaleString().replace(/1/g, "");
	var decimalSeparator = (1.1).toLocaleString().replace(/1/g, "");

	return parseFloat(formattedNumber.replace(new RegExp("\\" + thousandSeparator, "g"), "").replace(new RegExp("\\" + decimalSeparator), "."));
};

export const parseToNumber = (stringNumber, locale = "en-US") => {
	let thousandSeparator = Intl.NumberFormat(locale)
		.format(11111)
		.replace(/\p{Number}/gu, "");
	let decimalSeparator = Intl.NumberFormat(locale)
		.format(1.1)
		.replace(/\p{Number}/gu, "");

	return parseFloat(
		stringNumber
			.substring(1)
			.replace(new RegExp("\\" + thousandSeparator, "g"), "")
			.replace(new RegExp("\\" + decimalSeparator), ".")
	);
};

export const toastGenerator = ({ payrollConfirmAlert = false, status = "success", message = "" }) => {
	const toastTitle = {
		success: () => `Information`,
		warning: () => `Information`,
		error: () => `Something went wrong`,
	};
	const toastDescription = {
		success: () => (message ? message : `Data has been saved.`),
		warning: () => (message ? message : `Unable to save data.`),
		error: () => (message ? message : `Please try again.`),
	};

	return {
		title: toastTitle[status](),
		description: toastDescription[status](),
		fontSize: "sm",
		status: status,
		variant: "subtle",
		duration: payrollConfirmAlert ? 80000 : 3000,
		position: "top",
		isClosable: true,
	};
};

export function getBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
}

export const isValidDate = (value) => {
	return value && value instanceof Date && !isNaN(value) ? value : null;
};

export function exportTableToExcel(tableID, filename = "") {
	var downloadLink;
	var dataType = "data:text/csv;charset=utf-8,%EF%BB%BF";
	var tableSelect = document.getElementById(tableID);
	var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

	// Specify file name
	filename = filename ? filename + ".xls" : "excel_data.xls";

	// Create download link element
	downloadLink = document.createElement("a");

	document.body.appendChild(downloadLink);

	if (navigator.msSaveOrOpenBlob) {
		var blob = new Blob(["\ufeff", tableHTML], {
			type: dataType,
		});
		navigator.msSaveOrOpenBlob(blob, filename);
	} else {
		// Create a link to the file
		downloadLink.href = "data:" + dataType + ", " + tableHTML;

		// Setting the file name
		downloadLink.download = filename;

		//triggering the function
		downloadLink.click();
	}
}

export const startOf = (type, date = new Date()) => {
	let result;
	switch (type) {
		case "day":
			result = new Date();
			break;
		case "week":
			let day = date.getDay();
			result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (day === 0 ? -6 : 1) - day);
			break;
		case "month":
			result = new Date(date.getFullYear(), date.getMonth(), 1);
			break;
		case "year":
			result = new Date(date.getFullYear(), 0, 1);
			break;
		default:
			result = date;
	}
	return result;
};

export const endOf = (type, date = new Date()) => {
	let result;
	switch (type) {
		case "day":
			result = new Date();
			break;
		case "week":
			let day = date.getDay();
			result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (day === 0 ? 0 : 7) - day);
			break;
		case "month":
			result = new Date(date.getFullYear(), date.getMonth() + 1, 0);
			break;
		case "year":
			result = new Date(date.getFullYear(), 11, 31);
			break;
		default:
			result = date;
	}
	return result;
};

export function formatBytes(bytes, decimals = 2) {
	if (bytes === 0) return "0 Bytes";

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

//convert date from Enlish to Khmer
export function KhMonth(date, day, mm, year){
	let Khmer = "";
	let month = format(new Date(date), "M");
	switch (month) {
		case "1": Khmer = "មករា"; break;
		case "2": Khmer = "កុម្ភៈ"; break;
		case "3": Khmer = "មិនា"; break;
		case "4": Khmer = "មេសា"; break;
		case "5": Khmer = "ឧសភា"; break;
		case "6": Khmer = "មិថុនា"; break;
		case "7": Khmer = "កក្កដា"; break;
		case "8": Khmer = "សីហា"; break;
		case "9": Khmer = "កញ្ញា"; break;
		case "10": Khmer = "តុលា"; break;
		case "11": Khmer = "វិច្ឆការ"; break;
		case "12": Khmer = "ធ្នូ";break;
		default: Khmer = "";
	}
	if(day === "dd" && mm === "mm" && year === "yyyy"){
		return format(new Date(date), "dd") + " " + Khmer + " " +format(new Date(date), "yyyy")
	}else if(mm === "mm" && year === "yyyy"){
		return Khmer + " " + format(new Date(date), "yyyy")
	}
}

//Conver second to Hour Min Second
export function convertSecondsToHMS(seconds) {
	if(seconds === undefined){
		seconds = 0;
	}
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainingSeconds = seconds % 60;
  
    var result = '';
    if (hours > 0) { 
	 	// eslint-disable-next-line
      	result += hours + 'h' + ', ';
    }
    if (minutes > 0) {  
		// eslint-disable-next-line
      	result += minutes + 'min' + ', ';
    }
    result += remainingSeconds + 's';
  
    return result;
}

//short sentence ...
export function shortenSentence(sentence, maxLength = 30) {
	if (sentence?.length > maxLength) {
	  return sentence.slice(0, maxLength) + "...";
	}
	return sentence;
}

export const calculateDuration = (start, end) => {
    const startTime = moment(start, 'HH:mm:ss');
    const endTime = moment(end, 'HH:mm:ss');
    const duration = moment.duration(endTime.diff(startTime));
    const durationHours = Math.floor(duration.asHours());
    const durationMinutes = duration.minutes();
    const durationSeconds = duration.seconds();

	return `${durationHours}:${durationMinutes}:${durationSeconds}`;
};

// * get name of use device | windows, mac, ios, android, etc.
export const getUA = () => {
  let device = "Unknown";
  const ua = {
    "Generic Linux": /Linux/i,
    Android: /Android/i,
    BlackBerry: /BlackBerry/i,
    Bluebird: /EF500/i,
    "Chrome OS": /CrOS/i,
    Datalogic: /DL-AXIS/i,
    Honeywell: /CT50/i,
    iPad: /iPad/i,
    iPhone: /iPhone/i,
    iPod: /iPod/i,
    macOS: /Macintosh/i,
    Windows: /IEMobile|Windows/i,
    Zebra: /TC70|TC55/i,
  };
  Object.keys(ua).map((v) => navigator.userAgent.match(ua[v]) && (device = v));
  return device;
};

// * mask phone number *******1234
export const maskPhoneNumber = (phoneNumber) => {
	if (!phoneNumber || phoneNumber.length < 4) return phoneNumber;
	return phoneNumber.slice(0, -4).replace(/./g, '*') + phoneNumber.slice(-4);
};

// * check is phone number
export const isPhoneNumber = (input) => {
	// Remove all non-digit characters
  const cleanedInput = input.replace(/\D/g, '');
  
  // Check if the cleaned input is between 7 and 15 digits
  if (cleanedInput.length < 7 || cleanedInput.length > 15) {
    return false;
  }
  
  // Basic format check
  const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{3,14}$/;
  
  return phoneRegex.test(input);
};

export function phoneNumberFormat(phoneNumber) {
  const phone = phoneNumber.replace(/[^\d]/g, "");
  const match = phone.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  if (match) {
    const intlCode = match[1] ? `${match[1]} ` : "";
    return `${intlCode}${match[2] ? `${match[2]} ` : ""}${match[3] ? `${match[3]}` : ""}`;
  }
  return phoneNumber;
}